import './App.css';
import Navbar from './Components/Navbar';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import Home from './Views/Home';
import { Route, Routes, Navigate } from 'react-router-dom';
import SupplierManagement from './Views/SupplierManagement';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CategoryManagemnet from './Views/CategoryManagemnet';
// Disabled for this client: import AdminPanel from './Views/AdminPanel';
import ItemManagement from './Views/ItemManagement';
import Billing from './Views/Billing';
// Disabled for this client: import BarcodeGenerator from './Views/BarcodeGenerator';
import Grn from './Views/Grn';
import ReportModule from './Views/ReportModule';
import StockAllocation from './Views/StockAllocation';
import UserManagement from './Views/UserManagement';
// Disabled for this client: import StockReturn from './Views/StockReturn';
import Billhistory from './Views/Billhistory';
import Expenses from './Views/Expenses';
// Disabled for this client: import OrderTracking from './Views/OrderTracking';
// Disabled for this client: import CustomerDashboard from './Views/CustomerDashboard';

import { drawerRoute } from './Data/Data';
import { getSession } from './Data/auth';
import { BRAND } from './Data/brand';

// Routes and navigation share the same module permissions.
const moduleComponents = {
  '/billing': Billing,
  '/BillHistory': Billhistory,
  '/Expenses': Expenses,
  '/SupplierManagement': SupplierManagement,
  '/CategoryManagement': CategoryManagemnet,
  '/UserManagement': UserManagement,
  '/ItemManagement': ItemManagement,
  '/grn': Grn,
  '/StockAllocation': StockAllocation,
  '/ReportModule': ReportModule,
};

// Set theme on MUI
const theme = createTheme({
  palette: {
    primary: { main: BRAND.colors.primary, dark: BRAND.colors.primaryDark, contrastText: BRAND.colors.white },
    secondary: { main: BRAND.colors.white, contrastText: BRAND.colors.primary },
    third: { main: BRAND.colors.white },
    background: { default: BRAND.colors.white, paper: BRAND.colors.white },
    text: { primary: '#241B1B', secondary: '#6B5655' },
  },
  components: {
    MuiCardHeader: { styleOverrides: { title: { color: BRAND.colors.primary } } },
    MuiTableHead: { styleOverrides: { root: { backgroundColor: BRAND.colors.primary } } },
    MuiTableCell: { styleOverrides: { head: { color: BRAND.colors.white, fontWeight: 700 } } },
    MuiIconButton: { styleOverrides: { root: { color: BRAND.colors.primary } } },
  },
});

// Role-based route wrapper
const ProtectedRoute = ({ element, roles }) => {
  const userRole = Number(getSession()?.role);
  // Redirect if the user's role is not in the allowed roles
  return roles.includes(userRole) ? element : <Navigate to="/" replace />;
};

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {drawerRoute.map(({ path, roles }) => {
            const Module = moduleComponents[path];
            return <Route key={path} path={path} element={<ProtectedRoute element={<Module />} roles={roles} />} />;
          })}
          {/* Modules disabled for this client:
          <Route path="/OrderTracking" element={<OrderTracking />} />
          <Route path="/CustomerDashboard" element={<CustomerDashboard />} />
          <Route path="/barcodeGen" element={<BarcodeGenerator />} />
          <Route path="/StockReturn" element={<StockReturn />} />
          <Route path="/AdminPanel" element={<AdminPanel />} />
          <Route path="/Reservations" element={<Reservations />} />
          */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          toastStyle={{
            backgroundColor: BRAND.colors.primary,
            color: "white",
          }}
        />
      </ThemeProvider>
    </>
  );
}

export default App;
